/* ===================================
   CUSTOM CAROUSEL SCRIPT - SHOPIFY
   Funcionalidade: APENAS SWIPE (Sem Autoplay)
   =================================== */

(function() {
  'use strict';

  class SwipeOnlyCarousel {
    constructor() {
      this.currentIndex = 0;
      this.touchStartX = 0;
      this.touchEndX = 0;
      this.isDragging = false;
      this.dragStartX = 0;
      this.dragOffset = 0;
      this.init();
    }

    init() {
      // Aguardar o DOM estar completamente carregado
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setupCarousel());
      } else {
        this.setupCarousel();
      }
    }

    setupCarousel() {
      // Selecionar o container do carrossel
      const carouselContainer = document.querySelector('[role="region"][aria-label*="product"] .product-media-container') ||
                               document.querySelector('.product-media-container') ||
                               document.querySelector('[data-product-media-container]');

      if (!carouselContainer) {
        console.warn('Carrossel não encontrado.');
        return;
      }

      this.container = carouselContainer;
      this.gallery = this.container.querySelector('.product-media-gallery') ||
                    this.container.querySelector('[data-product-media-gallery]');
      
      if (!this.gallery) {
        console.warn('Galeria de mídia não encontrada.');
        return;
      }

      this.items = this.gallery.querySelectorAll('.product-media-item') ||
                  this.gallery.querySelectorAll('[data-product-media-item]');

      if (this.items.length === 0) {
        console.warn('Nenhum item de mídia encontrado.');
        return;
      }

      // Anexar listeners de eventos
      this.attachEventListeners();
      
      // Atualizar carrossel
      this.updateCarousel();
    }

    attachEventListeners() {
      // Eventos de touch para swipe
      this.gallery.addEventListener('touchstart', (e) => this.handleTouchStart(e), false);
      this.gallery.addEventListener('touchmove', (e) => this.handleTouchMove(e), false);
      this.gallery.addEventListener('touchend', (e) => this.handleTouchEnd(e), false);

      // Eventos de mouse para drag (desktop)
      this.gallery.addEventListener('mousedown', (e) => this.handleMouseDown(e), false);
      this.gallery.addEventListener('mousemove', (e) => this.handleMouseMove(e), false);
      this.gallery.addEventListener('mouseup', (e) => this.handleMouseUp(e), false);
      this.gallery.addEventListener('mouseleave', (e) => this.handleMouseUp(e), false);

      // Suporte a teclado
      document.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.prevSlide();
        if (e.key === 'ArrowRight') this.nextSlide();
      });
    }

    handleTouchStart(e) {
      this.touchStartX = e.changedTouches[0].screenX;
      this.isDragging = true;
    }

    handleTouchMove(e) {
      if (!this.isDragging) return;
      
      const currentX = e.changedTouches[0].screenX;
      this.dragOffset = currentX - this.touchStartX;
      
      // Feedback visual enquanto arrasta
      const offset = (-this.currentIndex * 100) + (this.dragOffset / this.gallery.offsetWidth * 100);
      this.gallery.style.transition = 'none';
      this.gallery.style.transform = `translateX(${offset}%)`;
    }

    handleTouchEnd(e) {
      this.isDragging = false;
      this.touchEndX = e.changedTouches[0].screenX;
      this.handleSwipe();
    }

    handleMouseDown(e) {
      this.isDragging = true;
      this.dragStartX = e.clientX;
    }

    handleMouseMove(e) {
      if (!this.isDragging) return;
      
      const currentX = e.clientX;
      this.dragOffset = currentX - this.dragStartX;
      
      // Feedback visual enquanto arrasta
      const offset = (-this.currentIndex * 100) + (this.dragOffset / this.gallery.offsetWidth * 100);
      this.gallery.style.transition = 'none';
      this.gallery.style.transform = `translateX(${offset}%)`;
    }

    handleMouseUp(e) {
      if (!this.isDragging) return;
      this.isDragging = false;
      
      const dragEndX = e.clientX;
      const dragDistance = this.dragStartX - dragEndX;

      // Sensibilidade: 50px de movimento necessário
      if (dragDistance > 50) {
        this.nextSlide();
      } else if (dragDistance < -50) {
        this.prevSlide();
      } else {
        // Voltar para a posição original se não atingiu a sensibilidade
        this.updateCarousel();
      }
    }

    handleSwipe() {
      const swipeDistance = this.touchStartX - this.touchEndX;

      // Sensibilidade: 50px de movimento necessário
      if (swipeDistance > 50) {
        this.nextSlide();
      } else if (swipeDistance < -50) {
        this.prevSlide();
      } else {
        // Voltar para a posição original se não atingiu a sensibilidade
        this.updateCarousel();
      }
    }

    updateCarousel() {
      // Atualizar posição da galeria
      const offset = -this.currentIndex * 100;
      this.gallery.style.transition = 'transform 0.5s ease-in-out';
      this.gallery.style.transform = `translateX(${offset}%)`;

      // Atualizar atributos ARIA para acessibilidade
      this.items.forEach((item, index) => {
        item.setAttribute('aria-hidden', index !== this.currentIndex);
      });
    }

    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.items.length;
      this.updateCarousel();
    }

    prevSlide() {
      this.currentIndex = (this.currentIndex - 1 + this.items.length) % this.items.length;
      this.updateCarousel();
    }
  }

  // Inicializar o carrossel quando a página carregar
  new SwipeOnlyCarousel();
})();
